import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getFeatureFlagsAll = async () => {
	const headers = {
		'Content-Type': 'application/json',
	};
	try {
		const response = await axios.get(
			`${API_BASE_URL}/auth/v1/getFeatureFlagsAll`,
			{
				headers,
				withCredentials: true,
			},
		);
		return response.data;
	} catch (error) {
		console.error('Error getFeatureFlagsAll :', error);
		return false;
	}
};
